import React from 'react';
import { HeartHandshakeIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { Governance } from '../components/Governance';
import { SectionNav } from '../components/SectionNav';
const CIVIC = [{
  title: 'Financial stewardship of charitable funds',
  body: 'As Treasurer, maintains the books, budget, and annual filings of a 501c3 organization serving older residents of Stamford, Connecticut.'
}, {
  title: 'Community sport and youth development',
  body: 'Supports the governance and long-term sustainability of Gaelic football and hurling in the New York metropolitan Irish community.'
}, {
  title: 'Mentoring finance professionals',
  body: 'Informal mentorship of early-career accountants and regulatory reporting analysts across the institutions he has led.'
}];
export function GovernancePage() {
  return <>
      <PageHeader index="09" title="Board Experience, Education & Civic Leadership" intro="Governance experience beyond the corporate role: nonprofit board seats held today, formal education, professional licensure, and civic commitment." data-id="element-371" data-mp="3itwihy5smn7u" />

      <Governance data-id="element-372" data-mp="1149xk9njfskn" />

      <section aria-labelledby="civic" className="w-full bg-navy-950" data-id="element-373" data-mp="w6q78bdkfpcc">
        <div className="mx-auto max-w-content px-6 py-20 sm:py-24 lg:px-8" data-id="element-374" data-mp="w92un423erws">
          <h2 id="civic" className="flex items-center gap-3 text-[11px] font-semibold uppercase tracking-widest text-gold-400" data-id="element-375" data-mp="s4v4r3jwf5wz">
            <HeartHandshakeIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-376" data-mp="ifbm9z03le2n" />
            Civic Leadership
          </h2>
          <ul className="mt-10 grid grid-cols-1 gap-px bg-white/10 lg:grid-cols-3" data-id="element-377" data-mp="dh1odgmznzdc">
            {CIVIC.map(item => <li key={item.title} className="bg-navy-950 p-8" data-id="element-378" data-mp="8fkrdw7mkx21">
                <p className="font-serif text-lg leading-snug text-white" data-id="element-379" data-mp="4eis5fdpkl02">{item.title}</p>
                <p className="mt-4 text-sm leading-relaxed text-slateink-300" data-id="element-380" data-mp="3vn6d3u81e673">
                  {item.body}
                </p>
              </li>)}
          </ul>
        </div>
      </section>

      <SectionNav currentIndex="09" data-id="element-381" data-mp="3q0w2f1pyjq8y" />
    </>;
}